import * as React from "react"
import { ReactNode } from "react"
import { Route, Routes } from 'react-router-dom'
import { Transactions } from './pages/Transactions'
import { AutomaticPayments } from './pages/AutomaticPayments'
import { Login } from "./pages/Login"

const transactionsIcon = require('../src/assets/icons/transactions-icon.png')
const automaticPaymentsIcon = require('../src/assets/icons/automatic-payments-icon.png')
// const faqIcon = require('../src/assets/icons/faq-icon.png')
const logoutIcon = require('../src/assets/icons/logout-icon.png')

type MenuItem = {
  component: ReactNode
  key: string
  label: string
  icon: JSX.Element
}

export const transactionsRoutes: MenuItem[] = [
  {
    component: <Transactions />,
    label: 'Transactions',
    key: '/transactions',
    icon: <img src={transactionsIcon} alt="" width="20" />
  },
  {
    component: <AutomaticPayments />,
    label: 'Automatic Payments',
    key: '/automatic-payments',
    icon: <img src={automaticPaymentsIcon} alt="" width="20" />
  },
]

export const RouteContent: React.FC = () => {
  const result: ReactNode[] = [
    <Route element={<Login />} key="/login" path="/login" />,
  ]

  const dfs = (routes: MenuItem[]) => {
    routes.forEach((item: MenuItem) => {
      result.push(
        <Route
          element={item.component}
          key={item.key}
          path={item.key}
        />
      )
    })
  }

  dfs(transactionsRoutes)
  return <Routes>{result}</Routes>
}

export const accountMenuItems = [
  // {
  //   key: '/faqs',
  //   label: 'FAQ',
  //   icon: <img src={faqIcon} alt="" width="30" />,
  // },
  {
    key: '/login',
    label: 'Log out',
    icon: <img src={logoutIcon} alt="" width="25" />,
  },
]
